<template>
  <div class="video_list">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true">
    </loading>
    <NavBar></NavBar>
    <div>
      <!-- <div v-if="isMobileApp"
           class="language-mobile">
        <div v-if="!userInfo">
          <a href="#"
             class="language-btn"
             v-b-modal.modal-guide>
          <b-icon-question-circle class="guide-svg"></b-icon-question-circle></a>
          <b-dropdown text="En/中"
                      right
                      class="language-btn">
            <b-dropdown-item @click="$i18n.locale='en'">English</b-dropdown-item>
            <b-dropdown-item @click="$i18n.locale='cn'">简体中文</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="mt-3">
          <button class="share-button"
                  @click="openShareModal()">
            <img src="static/images/video-share.png">
            <span class="div-description">
              {{ $t('video.descriptionL4') }}
            </span>
          </button>
        </div>
        {{ $t('video.descriptionL1') }}
        <br>
      </div>
      <div v-else>
        <div v-if="!userInfo"
             class="language-div">
          <a href="#"
             class="language-btn"
             v-b-modal.modal-guide>
            <b-icon-question-circle class="guide-svg"></b-icon-question-circle>
          </a>
          <b-dropdown text="En/中"
                      right
                      class="language-btn">
            <b-dropdown-item @click="$i18n.locale='en'">English</b-dropdown-item>
            <b-dropdown-item @click="$i18n.locale='cn'">简体中文</b-dropdown-item>
          </b-dropdown>
        </div>
        <button class="share-button mt-3"
                @click="openShareModal()">
          <img src="static/images/video-share.png">
          <span class="div-description">
            {{ $t('video.descriptionL4') }}
          </span>
        </button>
      </div> -->
      <div>
        <b-modal id="share-video-modal"
                 :title="$t('video.share') + ' ' + $t('video.name')"
                 hide-footer
                 hide-header
                 :visible="!isMobileScreen && sharingVideoURL!==null"
                 @hide="$store.commit('SET_SHARING_VIDEO_URL', null)">
          <ShareVideo v-bind:searchLabel="searchLabel"
                      :searchAllCategory="searchAllCategory"></ShareVideo>
        </b-modal>
      </div>
    </div>
    <div class="new_category">
      <div class="category_container">
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'tvseries'}">
            <img :src="searchCategory === 'tvseries' ? 'static/newVersionImgs/category_tvseries.svg' : 'static/newVersionImgs/nav_category_tvseries_active.svg'"
                 class="tv_series"
                 :style="{width:searchCategory === 'tvseries'?'':'25%',height:searchCategory === 'tvseries'?'':'25px'}">
            <span class="category_name">{{ $t('label.tvseries') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="selectNewVideoCategory('tvseries','all',0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'tvseries' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'tvseries' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'tvseries' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryTVseries')"
                   :key="idx"
                   @click="selectNewVideoCategory('tvseries',item.value,0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'tvseries' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'tvseries' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'tvseries' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'movies'}">
            <img :src="searchCategory === 'movies' ? 'static/newVersionImgs/nav_category_movie.svg' : 'static/newVersionImgs/category_movie.svg'"
                 class="tv_series">
            <span class="category_name">{{ $t('label.movie') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="selectNewVideoCategory('movies','all',1)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'movies' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'movies' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'movies' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryMovie')"
                   :key="idx"
                   @click="selectNewVideoCategory('movies',item.value,1)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'movies' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'movies' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'movies' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'entertainment'}">
            <img :src="searchCategory === 'entertainment' ? 'static/newVersionImgs/nav_category_entertainment.svg' : 'static/newVersionImgs/category_entertainment.svg'"
                 class="tv_series">
            <span class="category_name">{{ $t('label.ent') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="selectNewVideoCategory('entertainment','all',2)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'entertainment' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'entertainment' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'entertainment' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryEntertainment')"
                   :key="idx"
                   @click="selectNewVideoCategory('entertainment',item.value,2)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'entertainment' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'entertainment' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'entertainment' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'other'}">
            <img :src="searchCategory === 'other' ? 'static/newVersionImgs/nav_category_other.svg' : 'static/newVersionImgs/category_other.svg'"
                 class="tv_series">
            <span class="category_name">{{ $t('text.other') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="selectNewVideoCategory('other','all',3)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'other' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'other' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'other' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryOther')"
                   :key="idx"
                   @click="selectNewVideoCategory('other',item.value,3)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'other' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'other' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'other' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="language_container">
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          :width="$i18n.locale==='cn' ? 300 :370"
          :visible-arrow="false"
          :tabindex="9999"
          trigger="click">
          <div slot="reference"
               class="language_switch_btn">
            <span class="category_name">{{ $t('text.language') }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div style="width:100%;display:flex;align-item:center;justify-content:space-between;padding: 0 10px 0 10px;">
            <div>
              <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
                {{$t('label.listLanguageTitle')}}
              </div>
              <div style="display: flex;flex-direction: column;;align-item:center;justfy-content:space-around;">
                <div style="color: #666666;font-size: 14px;margin-top:5px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;padding-right:10px;"
                     @click="selectLanguageVideo('audio','all')"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="static/newVersionImgs/language_check.svg"
                         v-show=" searchLanguage === 'all'"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight:  searchLanguage === 'all' ? 'bold' : '',color:searchLanguage === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
                </div>
                <div style="color: #666666;font-size: 14px;margin-top:5px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;padding-right:10px;"
                     v-for="(item,idx) in $t('shareSound')"
                     :key="idx"
                     @click="selectLanguageVideo('audio',item.value)"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="static/newVersionImgs/language_check.svg"
                         v-show=" searchLanguage === item.value"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchLanguage === item.value ? 'bold' : '',color: searchLanguage === item.value ? '#000' : ''}">{{item.label}}</span>
                </div>
              </div>
            </div>
            <div>
              <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
                {{$t('label.listSubtitle')}}
              </div>
              <div style="display: flex;flex-direction: column;;align-item:center;justfy-content:space-around;">
                <div style="color: #666666;font-size: 14px;margin-top:5px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;padding-right:10px;"
                     @click="selectLanguageVideo('subtitle','all')"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="static/newVersionImgs/language_check.svg"
                         v-show=" searchSubtitleLanguage === 'all'"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight:  searchSubtitleLanguage === 'all' ? 'bold' : '',color:searchSubtitleLanguage === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
                </div>
                <div style="color: #666666;font-size: 14px;margin-top:5px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;padding-right:10px;"
                     v-for="(item,idx) in $t('shareLanguage')"
                     :key="idx"
                     @click="selectLanguageVideo('subtitle',item.value)"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="static/newVersionImgs/language_check.svg"
                         v-show=" searchSubtitleLanguage === item.value"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchSubtitleLanguage === item.value ? 'bold' : '',color: searchSubtitleLanguage === item.value ? '#000' : ''}">{{item.label}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- <div class="category">
      <div v-if="isWebsite">
        <div class="pc">
          <img class="home-img"
               src="static/images/home.png">
          <button v-bind:class="[isCategorySelected(0) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(0)">
            {{ $t('label.tvseries') }}
          </button>
          <button v-bind:class="[isCategorySelected(1) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(1)">
            {{ $t('label.movie') }}
          </button>
          <button v-bind:class="[isCategorySelected(2) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(2)">
            {{ narrowWidth ? $t('label.ent') : $t('label.entertainment') }}
          </button>
          <button v-bind:class="[isCategorySelected(3) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(3)">
            {{ $t('text.other') }}
          </button>
        </div>
        <div class="mobile">
          <div class="search-head">
            <img class="home-img"
                 src="static/images/home.png">
            <div class="search-div">
              <input class="search-input"
                     v-model="searchKeyWords"
                     @keyup.enter="searchVideos()"
                     style="padding:15px"
                     maxlength="20"
                     type="text">
            </div>
            <Profile v-if="websiteNarrowWidth"
                     class="usr-mobile"></Profile>
          </div>
          <div class="btn-group-mobile">
            <button v-bind:class="[isCategorySelected(0) ? 'category-button-active' : 'category-button', 'category-buttons']"
                    @click="selectCategory(0)">
              {{ $t('label.tvseries') }}
            </button>
            <button v-bind:class="[isCategorySelected(1) ? 'category-button-active' : 'category-button', 'category-buttons']"
                    @click="selectCategory(1)">
              {{ $t('label.movie') }}
            </button>
            <button v-bind:class="[isCategorySelected(2) ? 'category-button-active' : 'category-button', 'category-buttons']"
                    @click="selectCategory(2)">
              {{ narrowWidth ? $t('label.ent') : $t('label.entertainment') }}
            </button>
            <button v-bind:class="[isCategorySelected(3) ? 'category-button-active' : 'category-button', 'category-buttons']"
                    @click="selectCategory(3)">
              {{ $t('text.other') }}
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex_div mobile_flex">
          <img class="home-img"
               src="static/images/home.png">
          <div class="search-div">
            <input class="search-input"
                   style="padding:15px"
                   v-model="searchKeyWords"
                   @keyup.enter="searchVideos()"
                   type="text">
          </div>
          <Profile></Profile>
        </div>
        <div class="flex_div flex_div2">
          <button v-bind:class="[isCategorySelected(0) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(0)">
            {{ $t('label.tvseries') }}
          </button>
          <button v-bind:class="[isCategorySelected(1) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(1)">
            {{ $t('label.movie') }}
          </button>
          <button v-bind:class="[isCategorySelected(2) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(2)">
            {{ narrowWidth ? $t('label.ent') : $t('label.entertainment') }}</button>
          <button v-bind:class="[isCategorySelected(3) ? 'category-button-active' : 'category-button', 'category-buttons']"
                  @click="selectCategory(3)">
            {{ $t('text.other') }}
          </button>
        </div>
      </div>
    </div> -->
    <b-modal id="modal-guide"
             ref="guideModal"
             :title="$t('guide.title')"
             hide-footer>
      <div>
        <b-tabs content-class="mt-3"
                nav-class="guide-tabs">
          <b-tab :title="isWebsite? $t('guide.loginTitle') : $t('guide.loginMobileTitle')"
                 :active="!userInfo">
            <p>{{ $t('guide.loginText1') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img1.jpg">
            <p>{{ $t('guide.loginText2') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img2.jpg">
            <p>{{ $t('guide.loginText3') }}</p>
            <img class="guide-img"
                 src="static/images/guide-line.jpg">
            <p>{{ $t('guide.loginText4') }}</p>
            <img class="guide-img"
                 src="static/images/guide-facebook.jpg">
            <p>{{ $t('guide.loginText5') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img3.jpg">
            <img class="guide-img"
                 src="static/images/guide-img4.jpg">
          </b-tab>
          <b-tab :title="isWebsite? $t('guide.shareTitle') : $t('guide.shareMobileTitle')"
                 :active="userInfo">
            <div v-if="isWebsite">
              <p>{{ $t('guide.shareSubTitle1') }}</p>
              <p>{{ $t('guide.shareText1') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share1.jpg">
              <p>{{ $t('guide.shareText2') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share2.jpg">
              <p>{{ $t('guide.shareText3') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share3.jpg">
              <img class="guide-img"
                   src="static/images/guide-share4.jpg">
            </div>
            <div v-else>
              <p>{{ $t('guide.shareSubTitle2') }}</p>
              <p>{{ $t('guide.shareText4') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share5.jpg">
              <p>{{ $t('guide.shareText5') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share6.jpg">
              <p>{{ $t('guide.shareText6') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share7.jpeg">
              <img class="guide-img"
                   src="static/images/guide-share8.jpg">
            </div>
          </b-tab>
          <b-tab :title="isWebsite? $t('guide.ruleTitle') : $t('guide.ruleMobileTitle')">
            <p class="rule-text">{{ $t('guide.ruleText') }}</p>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <!-- <div class="top-20">
      <b-tabs v-model="languageTabIndex"
              @input="tabChanged"
              align="center">
        <b-tab :title="$t('language.cn')"></b-tab>
        <b-tab :title="$t('language.en')"></b-tab>
        <b-tab :title="$t('text.other')"></b-tab>
      </b-tabs>
    </div> -->
    <transition-group name="list"
                      tag="div"
                      class="video_container"
    >
      <div class="video"
           v-for="(item) in $store.state.country !== 'CN' ? videoList : videoListCN"
           :key="item.id"
           @mouseover="showGiftBtn(true,item.id)"
           @mouseleave="showGiftBtn(false,item.id)">
        <b-card
          tag="article"
          class="mb-2 video-card-pc">
          <!-- <b-card-img :top="true"
                      :src="showImage(item.thumbnails.high['url'])"
                      height="250"
                      :alt="item.title"
                      @click="chooseVideo(item)"
                      class="mb-3 pointer img-cover">
          </b-card-img> -->
          <el-image :src="showImage(item.thumbnails.high['url'])"
                    fit="cover"
                    :alt="item.title"
                    class="mb-3 pointer video_card_img"
                    @click="chooseVideo(item)">
            <div slot="placeholder"
                 class="image_slot">
              <img src="static/newVersionImgs/loading_img.svg">
            </div>
            <div slot="error"
                 class="image_slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <b-card-sub-title class="video-card-title pointer"
                            @click="chooseVideo(item)">
            <!-- #{{ index+1 }} {{ item.title }} -->
            {{ item.title }}
          </b-card-sub-title>
          <div class="petal-text"
               :id="item.id">
            <span>
              <button @click="selectPresentToVideo(1, item.id, item.source)"
                      :id="'gift-1-'+item.id"
                      v-bind:class="[isPresentSelected(1, item.id) ? 'petal-reward-btn-large-mobile' : 'petal-reward-btn-mobile']">
                <img v-bind:class="[isPresentSelected(1, item.id) ? 'petal-icon-large-mobile' : 'petal-icon-mobile']"
                     src="static/newVersionImgs/pp1.svg">
              </button>
              <button @click="selectPresentToVideo(2, item.id, item.source)"
                      :id="'gift-2-'+item.id"
                      v-bind:class="[isPresentSelected(2, item.id) ? 'petal-reward-btn-large-mobile' : 'petal-reward-btn-mobile']">
                <img v-bind:class="[isPresentSelected(2, item.id) ? 'petal-icon-large-mobile' : 'petal-icon-mobile']"
                     src="static/newVersionImgs/pp2.svg">
              </button>
              <button @click="selectPresentToVideo(3, item.id, item.source)"
                      :id="'gift-3-'+item.id"
                      v-bind:class="[isPresentSelected(3, item.id) ? 'petal-reward-btn-large-mobile' : 'petal-reward-btn-mobile']">
                <img v-bind:class="[isPresentSelected(3, item.id) ? 'petal-icon-large-mobile' : 'petal-icon-mobile']"
                     src="static/newVersionImgs/pp3.svg">
              </button>
            </span>
          </div>
          <!-- <b-card-text class="account-text pointer"
                       @click="chooseVideo(item)">
            <b>{{ item.account_name }}</b>
            <span> {{ displayDateTime(item.share_timestamp) }} </span>
          </b-card-text> -->

        </b-card>
      </div>
    </transition-group>
    <b-tooltip :target="tooltipTarge"
               :show.sync="showPresentTips"
               placement="bottom"
               triggers="hover focus">
      {{ $t('video.donateClickAgain') }} <br>
      <div v-if="selectedPresent == 1">
        ({{ $t('video.smallPresentTips') }})
      </div>
      <div v-if="selectedPresent == 2">
        ({{ $t('video.middlePresentTips') }})
      </div>
      <div v-if="selectedPresent == 3">
        ({{ $t('video.bigPresentTips') }})
      </div>
    </b-tooltip>
    <b-modal id="modal-give-petal-to-exist-video"
             :visible="!isMobileScreen && givePetalVideo!==null"
             title="Donate Petal to already shared Video"
             style="z-index:99999999999999"
             @hide="$store.commit('SET_GIVE_PETAL_VIDEO', null)"
             @ok="donateOrDislikeVideo()">
      <div v-if="givePetalVideo">
        <p> {{ $t('text.name') }}: {{ givePetalVideo['title'] }} </p>
        <p> {{ $t('share.rewardExistedL1') }} {{ givePetalVideo['account_name'] }}. </p>
        <p v-if="givePetalVideo['video_petal_balance']<=0">
          {{ $t('share.rewardExistedL2') }}
        </p>
        <p>{{ $t('share.rewardExistedL3') }}</p>
        <p> {{ $t('video.balance') }}: {{ givePetalVideo['video_petal_balance'] }} </p>
        <p v-if="userInfo"> {{ $t('account.balance') }}: {{ userBalance }} </p>
      </div>
      <b-input-group>
        <template v-slot:prepend>
          <b-input-group-text>Petal</b-input-group-text>
        </template>
        <b-form-input v-model="donateToVideoAmount"
                      type="number"></b-form-input>
      </b-input-group>
    </b-modal>
    <ChatRoom :userInfo="userInfo"></ChatRoom>
    <TabBar :userInfo="userInfo"></TabBar>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ChatRoom from '@/components/ChatRoom'
import NavBar from '@/components/NavBar'
import TabBar from '@/components/TabBar'
import { mapGetters, mapActions } from 'vuex'
import { donateToVideo, getUserInfo, getVideo, getCategory } from '@/utils/api'
import { parseYoutubeVideoID, parseBilibiliVideoID, parseTencentVideoId, parseSuboVideoId, displayBalance } from '@/utils/common'
import ShareVideo from '@/components/ShareVideo'
import { SMALL_GIFT, MIDDLE_GIFT, BIG_GIFT, BASE_URL } from '@/constants'
import {Base64} from 'js-base64'
export default {
    data() {
        return {
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            loading: false,
            page: 1,
            lastVideoNum: 0,
            currentVideoId: null,
            donateDismissCD: 0,
            selectedPresent: null,
            donateToVideoAmount: 10,
            categoryTabIndex: 0,
            languageTabIndex: 0,
            showPresentTips: false,
            tooltipTarge: 'gift',
            searchKeyWords: '',
            videoLoading: false,
            isMobileScreen: false
        }
    },
    computed: {
        ...mapGetters(['videoList', 'videoListCN', 'userInfo', 'sharingVideoURL', 'currentVideo', 'activePoint', 'userBalance', 'givePetalVideo', 'searchCategory', 'searchSubCategory', 'searchLanguage', 'searchSubtitleLanguage']),
        videoWidth() {
            let mw = Math.min(window.screen.width, window.screen.height)
            return this.isMobileApp || mw < 640 ? Math.min(mw, 320) : 640
        },
        videoHeight() {
            let mw = Math.min(window.screen.width, window.screen.height)
            return this.isMobileApp || mw < 640 ? 200 : 360
        },
        searchAllCategory() {
            let categories = [this.searchCategory, this.searchSubCategory]
            let res = ''
            for (let i = 0; i < categories.length; i++) {
                if (categories[i]) {
                    res += categories[i] + '|'
                }
            }
            return res.trim('|')
        },
        searchLabel() {
            let labels = [this.searchLanguage, this.searchSubtitleLanguage]
            let res = ''
            for (let i = 0; i < labels.length; i++) {
                if (labels[i]) {
                    res += labels[i] + '|'
                }
            }
            return res.trim('|')
        },
        narrowWidth() {
            return this.isMobileApp || window.screen.width < 500
        },
        websiteNarrowWidth() {
            return window.screen.width < 769
        }
    },
    mounted() {
        this.scroll()
    },
    created() {
        this.$store.dispatch('setIsPcClient', document.body.clientWidth > 768)
        this.getCategoryList()
        this.$store.commit('SET_CHANGE_NAVBAR_STYLE', false)
        this.isMobileScreen = document.body.clientWidth < 769
        if (this.$route.query.searchKeyWords) {
            this.chageSearchKeyWords(this.$route.query.searchKeyWords)
        }
        if (this.$route.query.category && this.$route.query.subcategory) {
            this.selectNewVideoCategory(this.$route.query.category, this.$route.query.subcategory, 0)
        }
        // this.updateCategoryTabIndex()
        // this.updateLanguageTabIndex()
        if (!this.loading) {
            this.clearVideos()
            this.refreshVideoList()
        }
        setInterval(this.updateDonateCD, 1000)
        if (document.body.clientWidth < 769) {
            this.$bvModal.hide('aboutModal')
            this.$bvModal.hide('shareLinkModal')
            this.$bvModal.hide('feedbackModal')
            this.$bvModal.hide('share-video-modal')
            this.$bvModal.hide('dailyRewardModal')
            this.$bvModal.hide('modal-give-petal-to-exist-video')
        }
        window.onresize = () => {
            this.$store.dispatch('setIsPcClient', document.body.clientWidth > 768)
            this.isMobileScreen = document.body.clientWidth < 769
            if (this.isMobileScreen) {
                this.$store.commit('SET_CHANGE_NAVBAR_STYLE', false)
                this.$store.commit('SET_SHARING_VIDEO_URL', null)
                this.$bvModal.hide('aboutModal')
                this.$bvModal.hide('shareLinkModal')
                this.$bvModal.hide('feedbackModal')
                this.$bvModal.hide('share-video-modal')
                this.$bvModal.hide('modal-give-petal-to-exist-video')
                this.$bvModal.hide('dailyRewardModal')
            } else {
                if (this.$route.name !== 'Home' && this.$route.name !== 'VideoDetail') {
                    this.$router.push('/')
                }
            }
        }
    },
    description: 'Shared Video',
    methods: {
        ...mapActions(['clearVideos', 'selectVideo', 'setSharingVideoURL', 'setGivePetalVideo', 'swapVideosInList', 'updateVideo', 'setUserInfo', 'selectVideo', 'setSharedVideoCount', 'setActivePoint', 'setUserBalance', 'setLanguageSearchLabel', 'setLanguageSearchSubtitleLabel', 'setCategorySearchLabel', 'setSubCategorySearchLabel', 'addActivePoint']),
        scroll() {
            window.onscroll = (e) => {
                if (document.body.clientWidth > 768) {
                    if (document.documentElement.scrollTop >= 100) {
                        this.$store.commit('SET_CHANGE_NAVBAR_STYLE', true)
                    } else {
                        this.$store.commit('SET_CHANGE_NAVBAR_STYLE', false)
                    }
                }
                let bottomOfWindow = Math.ceil(Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)) + window.innerHeight === document.documentElement.offsetHeight
                if (bottomOfWindow) {
                    this.loadNextPageVideos()
                }
            }
        },
        getCategoryList() {
            getCategory().then(res => {
            //     console.log(res.data)
                if (res.data.code === 0) {
                    let shareCategory = []
                    let shareSound = []
                    let shareSoundCN = []
                    let shareSoundEN = []
                    let shareLanguage = []
                    let shareLanguageCN = []
                    let shareLanguageEN = []

                    if (typeof (this.$t('shareCategory')) === 'object') {
                        for (let key in this.$t('shareCategory')) {
                            shareCategory.push(this.$t('shareCategory')[key])
                        }
                    } else {
                        shareCategory = this.$t('shareCategory')
                    }
                    Object.keys(res.data.data.category).map(item => {
                        shareCategory.map(val => {
                            if (val.value === item) {
                                let subcategoryEN = []
                                let subcategoryCN = []
                                res.data.data.subcategory[item].map(sub => {
                                    let subItemEN = {
                                        label: sub.en.subcategory.trim().toLowerCase().replace(sub.en.subcategory[0], sub.en.subcategory[0].toUpperCase()),
                                        value: sub.en.subcategory
                                    }
                                    let subItemCN = {
                                        label: sub.zh.subcategory,
                                        value: sub.en.subcategory
                                    }
                                    subcategoryEN.push(subItemEN)
                                    subcategoryCN.push(subItemCN)
                                })
                                switch (item) {
                                case 'tvseries':let shareSubCategoryTVseries = subcategoryEN
                                    this.$i18n.mergeLocaleMessage('en', {shareSubCategoryTVseries})
                                    shareSubCategoryTVseries = subcategoryCN
                                    this.$i18n.mergeLocaleMessage('cn', {shareSubCategoryTVseries})
                                    break
                                case 'movies':let shareSubCategoryMovie = subcategoryEN
                                    this.$i18n.mergeLocaleMessage('en', {shareSubCategoryMovie})
                                    shareSubCategoryMovie = subcategoryCN
                                    this.$i18n.mergeLocaleMessage('cn', {shareSubCategoryMovie})
                                    break
                                case 'entertainment':let shareSubCategoryEntertainment = subcategoryEN
                                    this.$i18n.mergeLocaleMessage('en', {shareSubCategoryEntertainment})
                                    shareSubCategoryEntertainment = subcategoryCN
                                    this.$i18n.mergeLocaleMessage('cn', {shareSubCategoryEntertainment})
                                    break
                                case 'other':let shareSubCategoryOther = subcategoryEN
                                    this.$i18n.mergeLocaleMessage('en', {shareSubCategoryOther})
                                    shareSubCategoryOther = subcategoryCN
                                    this.$i18n.mergeLocaleMessage('cn', {shareSubCategoryOther})
                                    break
                                default:break
                                }
                            }
                        })
                    })
                    res.data.data.audio.map(item => {
                        let soundItemCN = {
                            label: item[Object.keys(item)[0]].zh,
                            value: Object.keys(item)[0]
                        }
                        let soundItemEN = {
                            label: item[Object.keys(item)[0]].en,
                            value: Object.keys(item)[0]
                        }
                        shareSoundEN.push(soundItemEN)
                        shareSoundCN.push(soundItemCN)
                    })
                    shareSound = shareSoundEN
                    this.$i18n.mergeLocaleMessage('en', {shareSound})
                    shareSound = shareSoundCN
                    this.$i18n.mergeLocaleMessage('cn', {shareSound})

                    res.data.data.subtitle.map(item => {
                        let languageItemCN = {
                            label: item[Object.keys(item)[0]].zh,
                            value: Object.keys(item)[0]
                        }
                        let languageItemEN = {
                            label: item[Object.keys(item)[0]].en,
                            value: Object.keys(item)[0]
                        }
                        shareLanguageEN.push(languageItemEN)
                        shareLanguageCN.push(languageItemCN)
                    })
                    shareLanguage = shareLanguageEN
                    this.$i18n.mergeLocaleMessage('en', {shareLanguage})
                    shareLanguage = shareLanguageCN
                    this.$i18n.mergeLocaleMessage('cn', {shareLanguage})
                }
            }).catch(error => {
                console.log(error)
            })
        },
        showGiftBtn(val, id) {
            if (document.body.clientWidth > 768) {
                let giftBox = document.getElementById(id)
                if (val) {
                    giftBox.style.display = 'flex'
                    giftBox.style.alignItems = 'center'
                    giftBox.style.justifyContent = 'flex-end'
                } else {
                    giftBox.style.display = 'none'
                }
            }
        },
        chageSearchKeyWords(val) {
            this.searchKeyWords = val
            this.searchVideos()
        },
        loadNextPageVideos() {
            this.page = parseInt(this.videoList.length / 12) + 1
            this.refreshVideoList()
        },
        donateVideo(amount, videoId, videoSrc) {
            let token = localStorage.getItem('user_token')
            if (!amount) {
                amount = this.donateToVideoAmount
            }
            if (!amount) {
                alert('Invalid donate amount!')
                return
            }
            if (this.userBalance < Math.abs(amount)) {
                alert(this.$t('account.insufficientPetal', {'cost': Math.abs(amount), 'balance': this.userBalance}))
                return
            }
            if (navigator.vibrate) {
                navigator.vibrate(100)
            }
            donateToVideo(videoId, amount, token, videoSrc).then(res => {
                let resp = res.data
                if (resp && resp.status === 'ok') {
                    if (amount < 0) {
                        this.toast('b-toaster-top-left', 'Notification', this.$t('video.reduceVideoPetalSucc'))
                    } else {
                        this.toast('b-toaster-top-left', 'Notification', this.$t('video.donateToVideoSucc'))
                    }
                    this.updateVideo(resp.data)
                    this.updateUserInfo()
                    if (amount > 0) {
                        this.addActivePoint(Math.min(amount, BIG_GIFT) * 10 / BIG_GIFT)
                    }
                } else {
                    alert(this.$t('video.donateToVideoFail') + '(' + resp.message + ')')
                }
            }, respError => {
                alert(this.$t('video.donateToVideoFail') + '(' + respError + ')')
            })
        },
        toast(toaster, title, msg, append = false) {
            this.$bvToast.toast(msg, {
                title: title,
                toaster: toaster,
                autoHideDelay: 200,
                solid: true,
                appendToast: append
            })
        },
        donateCountDownChanged(dismissCountDown) {
            this.donateDismissCD = dismissCountDown
        },
        updateDonateCD() {
            if (this.donateDismissCD > 0) {
                this.showPresentTips = true
                this.donateDismissCD -= 1
            } else {
                this.showPresentTips = false
            }
        },
        isPresentSelected(presentIndex, videoId) {
            return this.selectedPresent === presentIndex && this.donateDismissCD && this.currentVideoId === videoId
        },
        isCategorySelected(tabIndex) {
            return tabIndex === this.categoryTabIndex
        },
        selectPresentToVideo(presentIndex, videoId, videoSrc) {
            this.showPresentTips = false
            if (!this.userInfo) {
                this.$bvModal.show('modal-login')
                return
            }
            this.tooltipTarge = 'gift-' + presentIndex + '-' + videoId
            if (this.donateDismissCD > 0 && this.selectedPresent === presentIndex && this.currentVideoId === videoId) {
                switch (presentIndex) {
                case 1:
                    this.donateVideo(SMALL_GIFT, videoId, videoSrc)
                    break
                case 2:
                    this.donateVideo(MIDDLE_GIFT, videoId, videoSrc)
                    break
                case 3:
                    this.donateVideo(BIG_GIFT, videoId, videoSrc)
                    break
                }
            } else {
                this.selectedPresent = presentIndex
            }
            this.donateDismissCD = 5
            this.currentVideoId = videoId
        },
        chooseVideo(video) {
            this.selectVideo(video)
            let path = '/video/' + video.id
            let query = {
                videoSrc: video.source,
                categoryIdx: this.categoryTabIndex
            }
            if (this.userInfo && this.isWebsite) {
                query['code'] = this.userInfo.ref_code
            }
            this.$router.push({
                path: path,
                query: query
            })
        },
        showBalance(petalBalance, precision = 0) {
            return displayBalance(petalBalance, precision)
        },
        selectNewVideoCategory(category, subcategory, idx) {
            this.setCategorySearchLabel(category)
            this.setSubCategorySearchLabel(subcategory)
            this.categoryTabIndex = idx
            this.searchKeyWords = ''
            this.clearVideos()
            this.page = 1
            this.lastVideoNum = 0
            this.refreshVideoList()
        },
        selectLanguageVideo(type, language) {
            if (type === 'audio') {
                this.setLanguageSearchLabel(language)
            } else {
                this.setLanguageSearchSubtitleLabel(language)
            }
            this.searchKeyWords = ''
            this.clearVideos()
            this.page = 1
            this.lastVideoNum = 0
            this.refreshVideoList()
        },
        selectCategory(index) {
            this.categoryTabIndex = index
            switch (index) {
            case 0:
                this.setCategorySearchLabel('tvseries')
                break
            case 1:
                this.setCategorySearchLabel('movie')
                break
            case 2:
                this.setCategorySearchLabel('entertainment')
                break
            case 3:
                this.setCategorySearchLabel('video')
                break
            default:
                this.setCategorySearchLabel('')
            }
            this.searchKeyWords = ''
            this.clearVideos()
            this.page = 1
            this.lastVideoNum = 0
            this.refreshVideoList()
        },
        tabChanged(tabIndex) {
            switch (this.languageTabIndex) {
            case 0:
                this.setLanguageSearchLabel('chinese')
                break
            case 1:
                this.setLanguageSearchLabel('english')
                break
            case 2:
                this.setLanguageSearchLabel('other_language')
                break
            default:
                this.setLanguageSearchLabel('')
            }
            this.searchKeyWords = ''
            this.clearVideos()
            this.page = 1
            this.lastVideoNum = 0
            this.refreshVideoList()
        },
        searchVideos() {
            if (this.searchKeyWords) {
                this.clearVideos()
                this.page = 1
                this.lastVideoNum = 0
                this.loading = true
                this.$store.dispatch('searchVideos', [this.searchKeyWords, this.page, 12, () => {
                    this.loading = false
                    let newVideoNum = this.videoList.length
                    this.lastVideoNum = newVideoNum
                    if (this.videoListCN.length < 10 && (this.videoList.length % 12) === 0 && this.$store.state.country === 'CN') {
                        this.loadNextPageVideos()
                    }
                }])
            }
        },
        refreshVideoList() {
            this.loading = true
            if (this.searchKeyWords) {
                this.$store.dispatch('searchVideos', [this.searchAllCategory, this.searchKeyWords, this.page, 12, () => {
                    this.loading = false
                    let newVideoNum = this.videoList.length
                    this.lastVideoNum = newVideoNum
                    if (this.videoListCN.length < 10 && (this.videoList.length % 12) === 0 && this.$store.state.country === 'CN') {
                        this.loadNextPageVideos()
                    }
                }])
            } else {
                this.$store.dispatch('getVideos', [this.searchAllCategory, this.searchLabel, this.page, 12, () => {
                    this.loading = false
                    let newVideoNum = this.videoList.length
                    this.lastVideoNum = newVideoNum
                    if (this.videoListCN.length < 10 && (this.videoList.length % 12) === 0 && this.$store.state.country === 'CN') {
                        this.loadNextPageVideos()
                    }
                }])
            }
        },
        openShareModal() {
            this.isMobileScreen = document.body.clientWidth < 769
            if (this.isMobileScreen) {
                this.$router.push('/shareVideo')
            } else {
                if (!navigator.clipboard) {
                    this.setSharingVideoURL('')
                    return
                }
                navigator.clipboard.readText().then(videoURL => {
                    let videoId = parseYoutubeVideoID(videoURL)
                    let videoIdBilibili = parseBilibiliVideoID(videoURL)
                    let videoIdTencent = parseTencentVideoId(videoURL)
                    let videoIdSubo = parseSuboVideoId(videoURL)
                    if (videoId) {
                        this.loading = true
                        getVideo(videoId).then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdBilibili) {
                        this.loading = true
                        getVideo(videoIdBilibili, 'bilibili').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdTencent) {
                        this.loading = true
                        getVideo(videoIdTencent, 'tencent').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdSubo) {
                        this.loading = true
                        getVideo(videoIdSubo, 'subo').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else {
                        this.setSharingVideoURL('')
                    }
                }).catch(() => {
                    this.setSharingVideoURL('')
                })
            }
        },
        donateOrDislikeVideo() {
            if (!this.userInfo) {
                alert(this.$t('home.notLoggedIn'))
                return
            }
            let token = localStorage.getItem('user_token')
            donateToVideo(this.givePetalVideo.id, this.donateToVideoAmount, token).then(res => {
                if (res.data && res.data.status === 'ok') {
                    if (this.donateToVideoAmount < 0) {
                        this.toast('b-toaster-top-left', 'Notification', this.$t('video.reduceVideoPetalSucc'))
                    } else {
                        this.toast('b-toaster-top-left', 'Notification', this.$t('video.donateToVideoSucc'))
                    }
                    this.$store.dispatch('getVideos', ['', 1, 12, false])
                    this.updateUserInfo()
                } else {
                    alert(this.$t('video.donateToVideoFail') + '(' + res.data.message + ')')
                }
            }, respError => {
                alert(this.$t('video.donateToVideoFail') + '(' + respError + ')')
            })
        },
        updateUserInfo() {
            getUserInfo().then(res => {
                this.setUserInfo(res.data)
            }).catch(error => {
                console.log(error)
            })
        },
        displayDateTime(ts) {
            return new Date(ts * 1000).toLocaleDateString()
        },
        searchChanged() {
            this.clearVideos()
            this.page = 1
            this.loading = true
            this.lastVideoNum = 0
            this.refreshVideoList()
        },
        updateCategoryTabIndex() {
            switch (this.searchCategory) {
            case 'tvseries':
                this.categoryTabIndex = 0
                break
            case 'movie':
                this.categoryTabIndex = 1
                break
            case 'entertainment':
                this.categoryTabIndex = 2
                break
            case 'video':
                this.categoryTabIndex = 3
                break
            }
        },
        updateLanguageTabIndex() {
            switch (this.searchLanguage) {
            case 'chinese':
                this.languageTabIndex = 0
                break
            case 'english':
                this.languageTabIndex = 1
                break
            case 'other_language':
                this.languageTabIndex = 2
                break
            }
        },
        showImage(url) {
            if (url.startsWith('http://')) {
                if (url.includes('qpic.cn') || url.includes('gtimg.cn') || url.includes('hdlsb.com')) {
                    return url.replace('http://', 'https://')
                } else {
                    return BASE_URL + '/api/v1/image/' + Base64.encode(url)
                }
            } else {
                return url
            }
        }
    },
    destroyed() {
        window.onscroll = null
        window.onresize = null
    },
    components: {
        Loading,
        ShareVideo,
        ChatRoom,
        NavBar,
        TabBar
    }
}
</script>
<style lang="scss">
    .popover_label{
        .label_title{
            height: 38px;
            border-radius: 8px;
            line-height: 38px;
            padding-left: 5px;
            white-space: nowrap;
        }
        .label_title:hover{
            background: #f2f2f2;
        }
    }
</style>
<style scoped lang="scss" >

.video_list{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFFFFF;

    .new_category{
        width: 80%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .category_container{
        width: 55%;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .video_type_btn{
            height: 44px;
            width: 156px;
            border-radius:22px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            background-color: #F2F2F2;

            .el-icon-arrow-down{
                color: rgba(0,0,0,1);
                font-weight: bold;
                width: 20%;
            }

            .tv_series{
                width: 20px;
                height: 17.5px;
                width: 20%;
            }

            .category_name{
                color: rgba(0,0,0,1);
                font-size: 16px;
                font-weight: bold;
                white-space: nowrap;
                width: 40%;
            }
        }

        .video_type_btn_active{
            background-color: #F06565;

            .el-icon-arrow-down{
                color: #FFFFFF;
            }

            .category_name{
                color: #FFFFFF;
            }
        }
        }

        .language_container{
            position: fixed;
            right: 10%;
            z-index: 2;
            background-color: #fff;
            border-radius:22px;

        .language_switch_btn{
            height: 44px;
            width: 136px;
            border-radius:22px;
            cursor: pointer;
            box-shadow:  0 5px 20px 0 RGBA(0, 0, 0, 0.25);
            display: flex;
            align-items: center;

             .category_name{
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                white-space: nowrap;
                margin-left: 20px;
            }

            .el-icon-arrow-down{
                color: #999999;
                font-weight: bolder;
                margin-left: 10px;
            }
        }
        }
    }

     @media screen and (max-width:768px){
    .new_category{
        display: none;
    }
    }

    .video_card_img{
        border-radius: 8px;
        width:95%;
        height:155px;
        margin-top: 10px;
        .image_slot{
            width: 100%;
            height: 170px;
            background-color: #EFEFEF;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 25px;
            img{
                width: 42px;
                height: 40px;
            }
        }
    }
}
.top-10 {
    margin-top: 10px;
}
.top-20 {
    margin-top: 20px;
}
.top-24 {
    margin-top: 24px;
}
.lr-10 {
    margin-left: 10px;
    margin-right: 10px;
}
.lr-20 {
    margin-left: 20px;
    margin-right: 20px;
}
.text-left {
    text-align: left;
}
.left {
    float: left;
}
.right {
    float: right;
}
.pointer {
    cursor: pointer;
}
.img-cover {
    object-fit: cover
}
.oneline {
    display: inline-block;
}
.search-text {
    margin-left: 30px;
    margin-right: 5px;
}
.search-select {
    width: 150px;
}
.video {
    margin: 3px;
}

.video_info {
    margin: 5px;
}
.subtitle {
    position: absolute;
    z-index: 10;
    text-align: center;
    transform: translate(-50%, -50%);
}
.subtitle-text {
    color: white;
    padding-left: 5px;
    padding-right: 5px;
    -webkit-text-stroke: 1px black;
    -webkit-text-fill-color: white;
    font-weight: bold;
    white-space: nowrap;
}
.subtitle-btn {
    display: inline;
}
.video-control {
    position: absolute;
    z-index: 20;
    width: 50px;
    transform: translate(-100%, -50%);
    padding: 2px;
}
.edit-subtitle-control {
    position: absolute;
    z-index: 20;
    width: 600px;
    transform: translate(-50%, -50%);
    padding: 2px;
}
.edit-subtitle-time-input {
    width: 120px;
    height: 38px;
}
.control-btn {
    margin-top: 1px;
    margin-bottom: 1px;
    width: 100%;
    opacity: 0.8;
}
.control-btn:hover{
    opacity: 1.0;
}
.petal-icon {
    width: 24px;
    height: 24px;
}
.petal-text {
  color: hotpink;
  display: none;
}
.video-card-pc {
    width: 22%;
    height: 260px;
    float: left;
    margin: 0 20px 0 20px;
    border-radius: 8px;
    border: none;
}

.video-card-pc :hover{
    background-color: #F2F2F2;
    border-radius: 8px;
}
.video_container{
    width: 80%;
}
@media only screen and (max-device-width: 30rem) {
    .video_container{
    width: 95%;
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5rem;
}
    .video{
        width: 48%;
        background-color: #fff !important;
        height: 150px;
    }
    .video-card-pc {
        width: 100%;
        height: 150px;
        margin: 0;
        box-shadow: 0 15px 25px 0 RGBA(0, 0, 0, 0.1);
        background-color: #fff !important;
    }
    .petal-text{
        display: none;
    }
      .video_card_img{
        border-radius: 8px;
        width:43vw !important;
        height:110px !important;
        margin: -5px 0 0 5px !important;
        .image_slot{
            width: 100%;
            height: 110px !important;;
            background-color: #EFEFEF;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 25px;
            img{
                width: 62px;
                height: 60px;
            }
        }
    }

    .video-card-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #000000 !important;
    width: 45vw !important;
    font-weight: 500;
    font-size: 16px;
    text-align: left;
    margin-top: 10px;
}
}
.language-div {
    position: absolute;
    right: 3%;
    top: 10%;
}
>>>.btn-secondary {
  border: none;
  background: transparent;
  color: #4A90E2;
}
.video-petal-mobile {
  height: 48px;
  margin-top: 12px;
}
.petal-icon-mobile {
  width: 24px;
  height: 24px;
}
.petal-reward-btn-mobile {
    background-color: transparent;
    border: none;
    width: 38px;
    height: 36px;
    margin-top: 3px;
    margin-bottom: 3px;
    margin-right: 10px;
}
.petal-reward-btn-mobile:focus {
    outline: 0 !important;
}
.petal-icon-large-mobile {
    width: 28px;
    height: 28px;
}
.petal-reward-btn-large-mobile {
    background-color: transparent;
    border: none;
    padding: 5px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 10px;
}
.petal-reward-btn-large-mobile:focus {
    outline: 0 !important;
}
.video-card-mobile {
    height: 7rem;
    padding: 0.1rem;
}
.sharer-mobile {
    font: 12px;
}
.video-card-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #000000 !important;
    font-weight: 400;
    margin-bottom: 10px;
    width: 95%;
    margin-left: 2.5%;
    font-weight: 500;
    font-size: 16px;
    text-align: left;
}
.search-icon {
    width: 30px;
    position: relative;
    top:6px;
    left: -50px;
    width: 30px;
    height: 30px;
}
.search-input {
    width: 430px;
    height: 50px;
    background-color: #E4E4E4;
    border-radius: 45px;
    margin-left: 25px;
    font-size: 20px;
    text-align: left;
    padding: 20px;
    outline:none;
}
.search-div {
    display: inline-block;
    height: 50px;
}
.div-description {
    width: 125px;
    height: 24px;
    font-size: 20px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FE4987;
    line-height: 24px;
    position: relative;
    top: 10px;
    left: -10px;
}
.account-text {
    font-weight: 400;
    color: #4A90E2;
    margin-top: 3px;
    margin-bottom: 7px;
}
.category {
    text-align: left;
    margin-top: 24px;
}
.home-img {
    width: 68px;
    height: 42px;
    margin-right: 22px;
    margin-left: 46px;
}
.category-buttons {
    font-size: 20px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    height: 50px;
    border-radius: 45px;
    border: none;
    margin: 0 5px;
}
.category-button-active{
    background: #FE4987;
}
.category-button {
    background: #000000;
}
.category-button:focus {
    outline: 0 !important;
}
.category-button-active:focus {
    outline: 0 !important;
}
.share-button {
    outline: none;
    background: #fafafa;
    border: 3px solid #FE4987;
    border-radius: 35px;
    padding: 5px 30px;
}
.share-button img {
    height: 67px;
    padding-bottom: 10px;
}
>>>.nav-tabs {
    font-size: 20px;
    font-family: Helvetica;
}
>>>.nav-tabs .nav-link {
    color: #131313;
    outline: none !important;
}
>>>.nav-tabs:hover {
    outline: none !important;
}
>>>.nav-link:focus {
    outline: none !important;
}
>>>.nav-tabs .nav-link.active {
    color: #4A90E2;
    background-color: white;
    border-radius: 26px 26px 0px 0px;
}
>>>.card-body {
    padding: 0px;
}
.list-enter-active { transition: all 1s; }
.list-enter, .list-leave-to { opacity: 0; }
.list-move { transition: transform 1s; }

.m-top-bottom-20 {
    margin-top: 20px;
    margin-bottom: 20px;
}
.left {
  float: left;
}
.language-btn {
  float: right;
  margin-right: 10px;
}
.modal-icon-text {
  font-size: 1.2rem;
}
.guide-img {
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
}
.rule-text {
  white-space: pre-line;
}
.guide-svg {
  width: 20px;
  height: 40px;
}
>>>.guide-tabs {
    justify-content: center;
    margin-top: 10px;
    font-size: 1rem;
}
>>>.modal-body {
    padding: 0px 55px;
}
>>>#modal-guide___BV_modal_body_ {
    padding: 0px 20px;
}
>>>.modal-content {
    border-radius: 26px;
}

.mobile{
    display: none;
}

@media only screen and (max-width:768px) {
    .pc{
        display: none
    }
    .mobile{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around
    }
    .search-head{
        display: flex;
        justify-content: space-around;
        align-items: center;

    }
    .flex_div{
        display: flex;
        justify-content: space-between;
        align-items: center;

    }
    .flex_div2{
        justify-content: space-around;
        margin:10px 0 0;
    }
    .mobile_flex{
        margin-top: 15px;
        width: 100%
    }
    .div-description{
        left: -15px;
    }
    .language-div{
    position: static;
    margin-bottom: 50px;
    border: 1px solid #ECEFF3;
    }
    .language-mobile{
    display: flex;
    flex-direction: column;
    }
    .home-img{
             width: 50px;
             height: 30px;
             /* margin: 10px 0px 0 25px; */
             margin:0;
    }
    .btn-group-mobile{
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-content: center;
        flex-wrap: wrap;
        margin-top: 10px;
    }
    .usr-mobile{
        margin-bottom: 10px;

    }
    .category{
        text-align: center;
        margin-top: 19px;
    }
    .category-buttons{
        font-size: 12px;
        margin: 0px;
        height:35px;
        width: 80px;
    }
    .search-div{
        width: 90%;
        display: flex;
        align-items: center
    }
    .search-input{
        width: 90%;
        height: 30px;
        /* margin-left: 20px; */
    }
    .video-card-mobile{
        width: 100%;
        padding: 0;
    }
    .card-img-left{
        /* width: 200px; */
        margin-top:10px;
        margin-right:10px
        /* margin: 10px */
    }
    .card{
        flex-direction: row;
    }
    .card-body{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 40%;
        font-size: 14px;
        height: 91%;
        margin-top: 10px;
    }
    .modal-dialog{
        width: 100px;
    }
    .sharer-mobile{
        text-align: center;
        color: #4A90E2;
        font-size: 13px;
    }
    .petal-reward-btn-mobile{
        width: 34px;
        height: 34px;
    }
    .petal-icon-mobile {
        width: 18px;
        height: 18px;
    }
    .petal-icon-large-mobile {
        width: 22px;
        height: 22px;
    }
    .petal-text{
        // display: flex;
        // justify-content: space-between;
        /* margin-top: 10px; */
    }
    .video{
        margin-top: 10px;
    }
    >>>.nav-tabs {
    font-size: 15px;
    font-family: Helvetica;
}
    >>>.nav-item{
        display: flex;
        height: 32px;
        justify-content: center;
    }
    >>>.nav-tabs .nav-link.active {
    color: #4A90E2;
    background-color: #F7F7F7;
    border-radius: 26px 26px 0px 0px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/VideoList.vue